import { render, staticRenderFns } from "./LoadingPanel.vue?vue&type=template&id=4158c86a&scoped=true"
import script from "./LoadingPanel.vue?vue&type=script&lang=ts"
export * from "./LoadingPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LoadingPanel.vue?vue&type=style&index=0&id=4158c86a&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4158c86a",
  null
  ,true
)

export default component.exports